import { useTranslation } from "react-i18next";
import "./ThankYou.css";

export default function ThankYou() {
  const { t, i18n } = useTranslation();

  // لو اللغة عربية نخلي الـ direction rtl
  const isArabic = i18n.language === "ar";

  return (
    <div className={`thank-you-container ${isArabic ? "rtl" : ""}`}>
      <div className="thank-you-box">
        <img
          src="/img/logo-g.png"
          alt="GPITCO Logo"
          className="thank-you-logo"
        />
        <h1 className="thank-you-title">{t("thankYou.title")}</h1>
        <p className="thank-you-message">{t("thankYou.message")}</p>
        <a href="/" className="thank-you-button">
          {t("thankYou.button")}
        </a>
      </div>
    </div>
  );
}
